import { Component } from '@angular/core';

@Component({
  templateUrl: './order-history-page.component.html'
})
export class OrderHistoryPageComponent {}
